import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { API_URL } from "../../services/api";
import { useCookies } from "react-cookie";

const SummaryModal = ({ show, handleClose, companyId }) => {
    const [token, setToken] = useCookies(["token"]);
    const [summary, setSummary] = useState({
        total: 0,
        lastWeek: 0,
        lastMonth: 0,
        today: 0,
        forms: []
    });

    useEffect(() => {
        if (show && companyId) {
            const headers = {
                headers: {
                    Authorization: `Bearer ${token.token}`,
                },
            };
            fetch(`${API_URL}companies/${companyId}/forms-summary`, headers)
                .then(response => response.json())
                .then(data => setSummary(data));
        }
    }, [show, companyId]);

    const styles = {
        summaryStats: {
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '20px',
            padding: '1rem'
        },
        statItem: {
            background: '#f8f9fa',
            borderRadius: '8px',
            padding: '1.5rem',
            textAlign: 'center',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            transition: 'transform 0.2s ease',
            cursor: 'pointer'
        },
        statTitle: {
            color: '#6c757d',
            fontSize: '1rem',
            marginBottom: '0.5rem',
            fontWeight: '600'
        },
        statValue: {
            color: '#0d6efd',
            fontSize: '2rem',
            fontWeight: 'bold',
            margin: '0'
        }
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Resumen de Formularios</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={styles.summaryStats}>
                    <div
                        style={styles.statItem}
                        onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-5px)'}
                        onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                    >
                        <h5 style={styles.statTitle}>Total Formularios</h5>
                        <p style={styles.statValue}>{summary.total}</p>
                    </div>
                    <div
                        style={styles.statItem}
                        onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-5px)'}
                        onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                    >
                        <h5 style={styles.statTitle}>Hoy</h5>
                        <p style={styles.statValue}>{summary.today}</p>
                    </div>
                    <div
                        style={styles.statItem}
                        onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-5px)'}
                        onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                    >
                        <h5 style={styles.statTitle}>Última Semana</h5>
                        <p style={styles.statValue}>{summary.lastWeek}</p>
                    </div>
                    <div
                        style={styles.statItem}
                        onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-5px)'}
                        onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                    >
                        <h5 style={styles.statTitle}>Último Mes</h5>
                        <p style={styles.statValue}>{summary.lastMonth}</p>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SummaryModal; 